export const palette = {
  grayUI: ["#ffffff", "#e8e8e8", "#c5c5c5", "#666", "#090909", "#000"],
  primaryUI: ["#ffffff", "#2275e2", "#2787ff", "#1d63c0", "#093570"],
};

export const theme = {
  fontFamily: "Roboto",
  colorScheme: "light",
  primaryShade: 8,
  primaryColor: "gray",
  headings: {
    fontFamily: "Roboto",
    fontWeight: "500",
    sizes: {
      h2: {
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "32px",
      },
    },
  },
  components: {
    Tabs: {
      styles: {
        tabLabel: {
          fontWeight: 500,
        },
      },
    },
    Select: {
      styles: {
        input: { height: "42px", fontSize: "14px", fontFamily: "Roboto" },
      },
    },
  },
};
